import { LogErrors } from './../../LogErrors'
import { UpdateGroupInstructor as DLUpdateGroupInstructor } from './../../DL/Leader/ChangeGroup'

// Importamos la función de Navigation para obtener el centro actual
import { GetCurrentCenter } from './../Navigation'


/**
 * Gestiona la transferencia de grupos entre dos instructores.
 * Construye el payload mapeando los idCenterUser que requiere el backend.
 * 
 * @param {number} idCenterUserOrigin - idCenterUser del instructor actual
 * @param {number} idCenterUserDestination - idCenterUser del instructor destino
 * @param {Array<number>} idsGroupsArray - Arreglo con los IDs de los grupos a mover
 */
const MoveGroupsBetweenInstructors = async (idCenterUserOrigin, idCenterUserDestination, idsGroupsArray) => {
    try {
        // 1. Validar sesión y obtener token
        if (!sessionStorage.getItem('userData')) {
            return { success: false, message: 'Tu sesión ha expirado.' }
        }
        const userData = JSON.parse(sessionStorage.getItem('userData'))
        const token = userData?.token
        
        if (!token) {
            return { success: false, message: 'Token de sesión no encontrado.' }
        }

        // 2. Obtener el centro actual utilizando el helper de Navigation
        const centerResponse = await GetCurrentCenter()
        if (!centerResponse.success || !centerResponse.data?.id) {
            return { success: false, message: 'No se pudo validar el centro actual para realizar la operación.' }
        }
        
        const idCenter = parseInt(centerResponse.data.id, 10)
        const rolLeader = 3 // Rol estático para Líder de Proyecto

        // 3. Armar el Payload exacto que espera el EndPoint
        const payload = {
            idInstructorOrigin: idCenterUserOrigin,           // El backend mapea esto a idCenterUser
            idInstructorDestination: idCenterUserDestination, // El backend mapea esto a idCenterUser
            idsGroups: idsGroupsArray,
            idCenter: idCenter,
            rol: rolLeader
        }

        // 4. Enviar a la capa de datos
        return await DLUpdateGroupInstructor(payload, token)
        
    } catch (error) {
        await LogErrors('MoveGroupsBetweenInstructors - BL Leaders ChangeGroup', error)
        return { success: false, message: 'Ocurrió un error interno al intentar preparar la transferencia.' }
    }
}

export { MoveGroupsBetweenInstructors };